import { cn } from 'lib/utils';
import * as React from 'react';

/**
 * Figma: "Input - Nova" (`input` border, `ring` focus). Diverges on purpose:
 * 44px tall and 16px radius instead of Figma's 32px / 8px, until the Figma
 * fields are polished; see docs/design-system.md.
 */
function Input({ className, type, ...props }: React.ComponentProps<'input'>) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        'file:text-foreground placeholder:text-subtle-foreground selection:bg-primary selection:text-primary-foreground border-input h-11 w-full min-w-0 rounded-lg border bg-card px-3 py-1 text-base shadow-xs transition-[color,box-shadow] outline-none file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm',
        'focus-visible:border-ring focus-visible:ring-ring/50 focus-visible:ring-[3px]',
        'aria-invalid:ring-ring-destructive/20 aria-invalid:border-ring-destructive',
        className,
      )}
      {...props}
    />
  );
}

export { Input };
